//react
import React from "react";

// mui
import { AppBar, Toolbar, Typography } from "@mui/material";

const Navbar = (props) => {
  return (
    <AppBar
      sx={{
        position: "fixed",
        marginBottom: "10px",
        height: { xs: "55px", sm: "50px", md: "40px" },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#007fff",
        
      }}
    >
      <Toolbar>
        <Typography sx={{ fontSize: "18px" }}>{props.title}</Typography>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
